<ng-template #attente>
  <br>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div *ngIf="enregistrementTerminer;else attente"></div>
<div *ngIf="generalService.cuurentUser != 'BIGDAR'"style="padding: 1rem;display: flex ;flex-direction: column; gap:0.5rem">

  <div>
    <mat-form-field style="width: 100%;">
      <textarea matInput [(ngModel)]="description" name="Description" placeholder="Description"
        style="margin-left: 10px; "></textarea>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field style="width: 100%;">
      <textarea matInput [(ngModel)]="keyWords" name="Mot clé" placeholder="Mot clé" 
        rows="30"></textarea>
    </mat-form-field>
  </div>
  <div style="display: flex; justify-content: end;">
    <div style="margin-right: 20px" class="button-row">
      <button type="button" (click)="enregistrer()" mat-raised-button class="colorBlue">Enregistrer</button>
    </div>
  </div>
</div> 
<div *ngIf="generalService.cuurentUser == 'BIGDAR'" style="padding: 1rem;display: flex ;flex-direction: column; gap:0.5rem">
  <div>
    <mat-form-field style="width: 100%;">
      <textarea matInput [(ngModel)]="description" name="Description" placeholder="Description"
        style="margin-left: 10px; "></textarea>
    </mat-form-field>
  </div>
  <div style="display: flex; flex-wrap: wrap; gap:1%">
    <div *ngFor="let cat of listCategorie;let i=index" style="width: 32%;display: flex; flex-direction: column; gap:0.5rem">
      <div >
        <mat-form-field style="width: 100%;">
          <input matInput style="margin-left: 10px;text-align: center; "  [(ngModel)]="cat.categorie_Text" readonly="true"  type="text" [placeholder]="'Catégorie '+(cat?.categorie_Text |  textPipe : 'capitalize')" [id]="'id'+i" [name]="'name'+i">
        </mat-form-field>
      </div>
      <div>
        <mat-form-field style="width: 100%;">
          <textarea matInput [(ngModel)]="listngModelTextArea[i]" [name]="'Mot clé'+i" [placeholder]="'Mot clé '+ (cat.categorie_Text |  textPipe : 'capitalize')" rows="18"></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div style="display: flex; justify-content: end;">
    <div style="margin-right: 20px" class="button-row">
      <button type="button"  (click)="concateAlltextareaAndPost()" mat-raised-button class="colorBlue">Enregistrer</button>
    </div>
  </div>
</div>
